<template>
  <table class="table table-dark">

    <thead>
      <tr>
        <th>&nbsp;</th>
        <th class="group-name text-color">{{ groupData.title }}</th>
        <template>
          <th class="text-center" v-for="f in groupData.fields" :title="fieldsNames[f]">{{ fieldsNamesSimplified[f] }}</th>
        </template>
      </tr>
    </thead>

    <tbody>
      <tr v-for="(team,index) in groupTable">
        <td>{{ index+1 }}</td>
        <td class="text-left text-white">{{ team.team_info.name }}</td>

        <template>
          <td v-for="f in groupData.fields" :class="`group-td-data `+f+`-field-td-data`">{{ team[f] }}</td>
        </template>
      </tr>
    </tbody>

  </table>
</template>

<script>

import EventRepository from "../../api/EventRepository";

export default {
  name: "Group",
  props:{
    id: Number,
    event: Number,
    group: Object
  },
  data: function(){
    return {
      isLoading: true,
      groupData:null,
      groupTable:null,
      fieldsNames:{
        'wins':'Wins',
        'draws':'Draws',
        'losses':'Losses',
        'played':'Played',
        'score_for':'Score For',
        'score_against':'Score Against',
        'score_difference':'Score Difference',
        'overtime_wins':'Wins Overtime (Map only)',
        'overtime_losses':'Losses Overtime (Map only)',
        'record':'Record',
        'record_difference':'Record Difference',
        'points':'Points'
      },
      fieldsNamesSimplified:{
        'wins':'W',
        'draws':'D',
        'losses':'L',
        'played':'P',
        'score_for':'RW',
        'score_against':'RL',
        'score_difference':'RD',
        'overtime_wins':'W OT',
        'overtime_losses':'L OT',
        'record':'Record',
        'record_difference':'Rec. Diff',
        'points':'P'
      }
    }
  },
  created: function(){
    this.getData();

  },
  methods: {
    getData(){
      this.groupData=this.$props.group;
      EventRepository.getGroupTable(this.$props.event,this.$props.id).then((response) => {
        this.isLoading = false;
        this.groupTable=response.data.data;
      });
    }
  },
  watch: {
    id: function(newVal, oldVal) { // watch it

      if(newVal !== oldVal){
        this.isLoading=true;
        this.getData();
      }

    }
  }
}
</script>

<style scoped>
  .groups-row .table {
    background-color: transparent;
    border: none;
  }

  .groups-row table thead {
    line-height:40px;
    height: 40px;
    font-family: Roboto;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    text-align: left;
  }

  .groups-row .table thead th {
    border:none;
    vertical-align: middle;
    color:#78838A;
  }

  .groups-row .group-name {
    font-weight: bolder;
    vertical-align: middle;
  }

  .groups-row tbody td {
    font-size: 14px;
  }

  .groups-row tbody tr:nth-child(odd){
    background-color: rgba(40, 51, 58, 0.51);
  }

  .groups-row .table td {
    border-top-color: rgba(0,0,0,0.2);
  }

  .group-td-data {
    color: #FFFFFF;
    opacity: 0.5;
  }

  .points-field-td-data {
    opacity: 1;
  }

</style>